(function () {
	var CACHE_KEY = 'fpc_prop65_geo';
	var CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

	function hideProp65Slides() {
		document.querySelectorAll('img[src*="PROP65" i]').forEach(function (img) {
			var slide = img.closest('.product-gallery-item, .thumbnail');
			if (slide) {
				slide.style.display = 'none';
			}
		});
	}

	function readCache() {
		try {
			var raw = localStorage.getItem(CACHE_KEY);
			if (!raw) {
				return null;
			}
			var cached = JSON.parse(raw);
			if (typeof cached.isCalifornia !== 'boolean' || typeof cached.expires !== 'number') {
				return null;
			}
			if (Date.now() > cached.expires) {
				return null;
			}
			return cached.isCalifornia;
		} catch (e) {
			return null;
		}
	}

	function writeCache(isCalifornia) {
		try {
			localStorage.setItem(CACHE_KEY, JSON.stringify({
				isCalifornia: isCalifornia,
				expires: Date.now() + CACHE_TTL_MS
			}));
		} catch (e) {
			// localStorage unavailable (private mode, quota, etc.) - just skip caching.
		}
	}

	function checkCalifornia() {
		var cached = readCache();
		if (cached !== null) {
			if (!cached) {
				hideProp65Slides();
			}
			return;
		}

		fetch('https://ipapi.co/json/')
			.then(function (response) {
				return response.ok ? response.json() : null;
			})
			.then(function (data) {
				if (!data) {
					return;
				}
				var isCalifornia = data.country_code === 'US' && data.region_code === 'CA';
				writeCache(isCalifornia);
				if (!isCalifornia) {
					hideProp65Slides();
				}
			})
			.catch(function () {
				// Geolocation lookup failed - leave the Prop 65 warning visible (safe default),
				// and don't cache the failure so the next visit retries.
			});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', checkCalifornia);
	} else {
		checkCalifornia();
	}
})();
